const appBundleId = process.env.NEXT_PUBLIC_APP_ENV === 'prod' ? 'com.singcolor.app' : 'com.singcolor.app.dev'

export const envVars = {
  webUrl: process.env.NEXT_PUBLIC_WEB_URL!,
  appCustomUrlScheme: `${appBundleId}://`
}
